import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  AdminAppAnalytics,
  AdminAppDisplaysComponent,
  AdminAppFeedbackComponent,
  AdminAppReportsFlagsComponent,
  AdminBrandsComponent,
  AdminCheckOutQuestions,
  AdminCustomersComponent,
  AdminLeaderboardComponent,
  AdminNotificationsComponent,
  AdminPageTabList,
  AdminProductsComponent,
  AdminReportsComponent,
  AdminUsersComponent,
  AdminVenuesComponent,
} from "../components";
import store from "../store";
import { SEARCH_ADMIN_INITIAL, SEARCH_ADMIN_UPDATE } from "../store/slices";
import { AdminInstance } from "../utils/adminClass";
import { AuthenticationInstance } from "../utils/authenticationClass";
import { Dashboard } from "./DashboardPage";

const tabs = [
  {
    title: "Users",
  },
  {
    title: "Venues",
  },
  {
    title: "Brands",
  },
  {
    title: "Products",
  },
  {
    title: "Business Requests",
  },
  {
    title: "App Displays",
  },
  {
    title: "App Feedback",
  },
  {
    title: "Reports/Flags",
  },
  {
    title: "Global Analytics",
  },
  {
    title: "Customers",
  },
  {
    title: "Notifications",
  },
  {
    title: "Check Out Questions",
  },
  {
    title: "Leaderboard",
  },
  {
    title: "Reports",
  },
];

export const AdminPage = ({ color }: { color: any }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const businesses = useSelector((state: any) => state.business);
  const [activeTab, setActiveTab] = useState(tabs[0]);

  useEffect(() => {
    console.log("activetab", activeTab);
    checkAdminStatus();
    const searchType = activeTab.title.toLowerCase().slice(0, -1) as "brand" | "venue" | "product" | "all" | "user";
    store.dispatch(
      SEARCH_ADMIN_UPDATE({
        data: {
          ...SEARCH_ADMIN_INITIAL,
          searchType,
        },
      }),
    );
  }, [activeTab]);

  const checkAdminStatus = async () => {
    const adminStatus = await AdminInstance.checkIfAdmin();
    if (!adminStatus) {
      navigate("/");
    }
    console.log("adminStatus", adminStatus);
  };

  const handleLogout = () => {
    AuthenticationInstance.handleSignOut();
  };

  const renderActiveTabContent = () => {
    switch (activeTab.title) {
      case "Users":
        return <AdminUsersComponent />;
      case "Customers":
        return <AdminCustomersComponent />;
      case "Venues":
        return <AdminVenuesComponent />;
      case "Brands":
        return <AdminBrandsComponent />;
      case "Products":
        return <AdminProductsComponent />;
      case "App Displays":
        return <AdminAppDisplaysComponent />;
      case "App Feedback":
        return <AdminAppFeedbackComponent />;
      case "Reports/Flags":
        return <AdminAppReportsFlagsComponent />;
      case "Global Analytics":
        return <AdminAppAnalytics />;
      case "Notifications":
        return <AdminNotificationsComponent />;
      case "Check Out Questions":
        return <AdminCheckOutQuestions />;
      case "Leaderboard":
        return <AdminLeaderboardComponent />;
      case "Reports":
        return <AdminReportsComponent />;
      default:
        return <div>No page created yet for this tab</div>;
    }
  };

  return (
    <Dashboard>
      <div style={{ marginTop: 24 }}>
        <AdminPageTabList tabs={tabs} onSelect={setActiveTab} activeTab={activeTab} />
      </div>
      <div>{renderActiveTabContent()}</div>
    </Dashboard>
  );
};
